import { PUBLIC_VERSION } from '../version.js';

if (typeof window !== 'undefined') {
	/*               */
	((window.__svelte ??= {}).v ??= new Set()).add(PUBLIC_VERSION);
}
